<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs4>
        <v-card-title>
          <div class="body-1">{{ this.title }}</div>
          <v-spacer></v-spacer>
          <v-icon @click="showSortOrderHelpList()">mdi-magnify</v-icon>
        </v-card-title>
        <v-card-text>
          <div v-if="showOrderError" class="small font-weight-300 red--text">{{ this.title + ' field is required.' }}</div>
        </v-card-text>
      </v-flex>
      <v-flex xs8>
        <v-data-table :headers="sortOrderHeader" :items="sortOrder" :no-data-text="noText" hide-default-footer item-key="text" ref="premSortOrder">
          <template v-slot:item="row">
            <tr :active="row.selected" :key="row.item.text">
              <td width="50px"><v-icon class="phSortIcon">mdi-cursor-move</v-icon></td>
              <td>{{ row.item.text }}</td>
              <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
            </tr>
          </template>
        </v-data-table>
        <p v-if="sortOrder.length > 1" align="center">Hold the icon to arrange the sequence</p>
      </v-flex>
    </v-layout>
    <!-- Sort Order HelpList -->
    <v-dialog v-model="showDialog" width="900px" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Sort Order Helplist</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="doSelect">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-spacer></v-spacer>
              <v-flex xs12 class="mt-3">
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="filterSortOrderList"
                :loading="loading"
                :custom-filter="customSearch"
                :no-data-text="noDataText"
                item-key="text"
                v-bind:search="search"
                v-model="selected"
              >
                <template v-slot:item="row">
                  <tr :active="row.selected" :key="row.item.text">
                    <td style="width: 50px">
                      <v-checkbox primary hide-details v-model="row.item.sort"></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ row.item.text }}</td>
                    <td>
                      <v-checkbox primary hide-details v-model="row.item.subTotal"></v-checkbox>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" dark class="mb-2" @click.prevent="showDialog = false">
                Cancel
                <v-icon dark right>mdi-cancel</v-icon></v-btn
              >
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Refresh
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="doSelect">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import Sortable from 'sortablejs'
export default {
  props: {
    title: {
      type: String,
      default: 'Sort Order By'
    },
    orderIdList: {
      type: Array,
      default: null
    },
    showOrderError: {
      type: Boolean,
      default: false
    },
    selectedSize: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      search: '',
      noText: 'Sort Order is Not Selected!',
      headers: [
        { text: '', value: 'sort', sortable: false },
        { text: 'Sort Order', value: 'text', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false }
      ],
      sortOrderList: [
        { id: 0, text: 'Agent', value: 'AG', subTotal: false, sort: false },
        { id: 1, text: 'Billing Account', value: 'BA', subTotal: false, sort: false },
        { id: 2, text: 'Branch', value: 'BR', subTotal: false, sort: false },
        { id: 3, text: 'Business Class', value: 'BC', subTotal: false, sort: false },
        { id: 4, text: 'Business Source', value: 'BS', subTotal: false, sort: false },
        { id: 5, text: 'Class Group', value: 'CG', subTotal: false, sort: false },
        { id: 6, text: 'Client Status', value: 'CS', subTotal: false, sort: false },
        { id: 7, text: 'Client Type', value: 'CT', subTotal: false, sort: false },
        { id: 8, text: 'Country', value: 'CO', subTotal: false, sort: false },
        { id: 9, text: 'Direct/RI', value: 'DR', subTotal: false },
        { id: 10, text: 'Executive In-charge', value: 'EX', subTotal: false, sort: false },
        { id: 11, text: 'Fund', value: 'FD', subTotal: false, sort: false },
        { id: 12, text: 'Intermediary Type', value: 'IT', subTotal: false, sort: false },
        { id: 13, text: 'Loss Year', value: 'LO', subTotal: false, sort: false },
        { id: 14, text: 'Noticed Year', value: 'NY', subTotal: false, sort: false },
        { id: 15, text: 'Policy Type', value: 'PT', subTotal: false, sort: false },
        { id: 16, text: 'Underwriting Year', value: 'UY', subTotal: false, sort: false }
      ],
      selected: [
        {
          subTotal: [],
          sort: []
        }
      ],
      errMsgLen: 'Allows up to ' + this.selectedSize + ' selections only',
      errMsgSel: 'Please select the Sort Order(s) before select the Sub Total(s)',
      origArr: [],
      sortOrder: [],
      sortOrderHeader: [
        { text: '', value: 'pgIcon', sortable: false },
        { text: 'Sort Order', value: 'text', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false }
      ],
      showDialog: false
    }
  },
  created() {
    this.origArr = clone(this.sortOrder)
    this.doInit()
  },
  methods: {
    doInit() {
      if (this.selectedSortOrderList.length !== 0) {
        this.selectedSortOrderList.map(sort => {
          const index = sort.id
          this.sortOrderList[index] = sort
          this.selected.push(sort)
        })
      }
    },
    doSelect() {
      const selectedItems = []
      const sort = this.sortOrderList
      const resultBoth = sort.filter(sort => sort.subTotal === true && sort.sort === true)
      const resultSubTotal = sort.filter(sort => sort.subTotal === true && sort.sort === false)
      const resultSortOrder = sort.filter(sort => sort.subTotal === false && sort.sort === true)
      const bothLength = resultBoth.length * 2
      const stLength = resultSubTotal.length
      const pbLength = resultSortOrder.length
      if (resultBoth.length + stLength + pbLength > this.selectedSize) {
        this.$toast.error(this.errMsgLen)
      } else if (stLength > 0) {
        this.$toast.error(this.errMsgSel)
      } else {
        if (bothLength !== 0) {
          for (var iBoth = 0; iBoth < resultBoth.length; iBoth++) {
            selectedItems.push(resultBoth[iBoth])
          }
        }
        if (stLength !== 0) {
          for (var iSt = 0; iSt < stLength; iSt++) {
            selectedItems.push(resultSubTotal[iSt])
          }
        }
        if (pbLength !== 0) {
          for (var iPb = 0; iPb < pbLength; iPb++) {
            selectedItems.push(resultSortOrder[iPb])
          }
        }
        const pageHeaderObj = {
          sort: selectedItems,
          from: 'sort'
        }
        this.doAssignSort(pageHeaderObj)
      }
    },
    doCancel() {
      const pageHeaderObj = {
        sort: this.origArr,
        from: 'sort'
      }
      this.$emit('doAssign', pageHeaderObj)
      this.$emit('close')
    },
    doReset() {
      for (let i in this.sortOrderList) {
        this.sortOrderList[i].sort = false
        this.sortOrderList[i].subTotal = false
      }
    },
    showSortOrderHelpList() {
      this.showDialog = true
      this.showOrderError = false
    },
    async doAssignSort(Obj) {
      this.sortOrder = []
      this.sortOrder = Obj.sort
      var sortOrderHtml = this.$refs['premSortOrder'].$el.firstElementChild.firstElementChild.tBodies[0]
      Sortable.create(sortOrderHtml, {
        group: 'premSortOrder', // group of data
        sort: true, // default allow to sort the table lst
        swapThreshold: 0.65, // the threshold position to swap the element
        delay: 1000, // time in milliseconds to define when the sorting should start
        delayOnTouchOnly: true, // only delay if user is using touch
        handle: '.phSortIcon', // to make this class to handle the sort
        animation: 150 // animation
      })
      this.showDialog = false
    }
  },
  computed: {
    filterSortOrderList() {
      if (this.orderIdList !== null) {
        return this.sortOrderList.filter(item => this.orderIdList.includes(item.value))
      }
      return this.sortOrderList
    },
    selectedSortOrderList() {
      return this.sortOrder
    },
    phNewSortHtml() {
      if (this.sortOrder.length === 0) {
        return ''
      } else {
        return this.$refs['premSortOrder'].$el.firstElementChild.firstElementChild.tBodies[0].rows
      }
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
